// import React from 'react';

// type YoutubeIFrameApi = typeof YT
// export const enum PlayerState
// {
// 	UNSTARTED = -1,
// 	ENDED = 0,
// 	PLAYING = 1,
// 	PAUSED = 2,
// 	BUFFERING = 3,
// 	CUED = 5
// }

// function loadYoutubeApiScript(): Promise<YoutubeIFrameApi> {
//   return new Promise(resolve => {
//     if (window.YT) {
//       resolve(window.YT)
//       return
//     }
//
//     // create script
//     const tag = document.createElement('script')
//     tag.src = '//www.youtube.com/iframe_api?_app_earlybirddk=1'
//     const firstScriptTag = document.getElementsByTagName('script')[0]
//     firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
//
//     // @ts-ignore
//     const previous = window.onYouTubeIframeAPIReady
//
//     // @ts-ignore
//     window.onYouTubeIframeAPIReady = () => {
//       if (previous) {
//         previous()
//       }
//       resolve(window.YT)
//     }
//   })
// }

const getYoutubeIdFromUrl = url => {
  let yid: string;

  url = url
    .replace(/([>|<])/gi, '')
    .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);

  if (url[2] !== undefined) {
    yid = url[2].split(/[^0-9a-z_-]/i)[0];
  } else {
    yid = url;
  }

  return yid;
};

interface IProps {
  src: string;
  alt?: string;
  title?: string;
}

// interface IState {
//   // url: string,
//   // yid: string,
//   play: boolean;
// }

export default function VideoIframe({ src, title, alt }: IProps) {
  const youtubeEmbedId = getYoutubeIdFromUrl(src);
  return (
    <div className="video featured is-playing">
      <iframe
        id="vid-player"
        className="video-frame"
        title={title || alt || 'Earlybird'}
        src={`//www.youtube.com/embed/${youtubeEmbedId}?enablejsapi=1&rel=0&showinfo=0&autoplay=0&_app_earlybirddk=1`}
      />
    </div>
  );
}
